import { render, staticRenderFns } from "./ListarColaboradores.vue?vue&type=template&id=2f3a21a5"
import script from "./ListarColaboradores.vue?vue&type=script&lang=js"
export * from "./ListarColaboradores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports